"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchLoad = void 0;
var consts_1 = require("../consts");
var searchLoad = function (event) {
    var _a, _b;
    var raw = event.eventData.searchLoad;
    var searchWithFallbacks = {
        searchFilter: raw.searchFilter || consts_1.NOT_AVAILABLE,
        searchPagination: (_a = raw.searchPagination) !== null && _a !== void 0 ? _a : consts_1.NOT_AVAILABLE,
        searchResults: (_b = raw.searchResults) !== null && _b !== void 0 ? _b : consts_1.NOT_AVAILABLE,
        searchSort: raw.searchSort || consts_1.NOT_AVAILABLE,
        searchTerm: raw.searchTerm || consts_1.NOT_AVAILABLE,
        searchType: raw.searchType || consts_1.NOT_AVAILABLE,
    };
    var eventData = {
        action: raw.searchResults === 0 ? 'search-no-results' : 'search-success',
        event: 'search-load',
        eventInfo: 'search-load',
        search: searchWithFallbacks,
    };
    return [eventData];
};
exports.searchLoad = searchLoad;
